export const Environments = {
  Development: "development",
  Production: "production",
  Staging: "staging",
};
